module.exports = __webpack_public_path__ + "img/facebook.2f15a5ec.svg";